<template>
    <div></div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    props: {
        configs: {
            type: Object,
            required: true,
        },
    },

    created: function () {
        this.setConfigs(this.configs)
    },

    methods: {
        ...mapMutations({
            setConfigs: 'configs/setConfigs',
        }),
    },
}
</script>
